import React from 'react'
import DOMPurify from 'isomorphic-dompurify'

interface IHTMLStringRenderer {
  htmlString: string
  className?: string
}

export function HTMLStringRenderer({
  htmlString,
  className,
}: IHTMLStringRenderer) {
  return (
    <p
      className={`string-renderer ${className}`}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(htmlString, { ADD_ATTR: ['target'] }),
      }}
    />
  )
}
